/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HalJson } from '../../models/hal-json';
import { ItemVariantTypeRequest } from '../../models/item-variant-type-request';

export interface ItemVariantTypesPost$Params {
  'Active-Tenant-Identifier': string;
      body: ItemVariantTypeRequest
}

export function itemVariantTypesPost(http: HttpClient, rootUrl: string, params: ItemVariantTypesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
'itemVariantTypeId'?: string;
}>> {
  const rb = new RequestBuilder(rootUrl, itemVariantTypesPost.PATH, 'post');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      '_links'?: HalJson;
      'itemVariantTypeId'?: string;
      }>;
    })
  );
}

itemVariantTypesPost.PATH = '/item-variant-types';
